<template>
  <section>
    <box-default>
      <div class="col-md-12 fl">

        <div class="fl-head">
          <div class="fl-head__title">
            <ion-icon name="scan-outline"/>
            <div>
              <h3>Novo Reconhecimento Facial</h3>
              <span>Teste da Face ID API (Zioncor) com fotos reais de registro de ponto</span>
            </div>
          </div>
          <button class="fl-btn fl-btn--ghost" :disabled="loadingHealth" @click="checkHealth()">
            <span v-if="!loadingHealth">Testar conexão</span>
            <span v-else>Testando...</span>
          </button>
        </div>

        <div v-if="healthResult" class="fl-health" :class="healthResult.success ? 'ok' : 'bad'">
          <ion-icon :name="healthResult.success ? 'checkmark-circle-outline' : 'alert-circle-outline'"/>
          <span v-if="healthResult.success">API respondeu {{ healthResult.httpStatus }} em {{ ms(healthResult.elapsedMs) }} — {{ healthResult.rawResponse }}</span>
          <span v-else>{{ healthResult.errorMessage }}</span>
          <button class="fl-x" @click="healthResult = null"><ion-icon name="close-outline"/></button>
        </div>

        <div class="fl-card fl-search">
          <div class="fl-field fl-field--grow">
            <label>Id do funcionário</label>
            <input v-model="userId" type="text" placeholder="Ex.: 3F2A9C1D8B4E4A7C9D0E1F2A3B4C5D6E"
                   @keyup.enter="searchPoints()"/>
          </div>
          <div class="fl-field">
            <label>Banco</label>
            <input v-model="bank" type="text" list="fl-banks" placeholder="AAAA" @keyup.enter="searchPoints()"/>
            <datalist id="fl-banks">
              <option v-for="b in banks" :key="b" :value="b"></option>
            </datalist>
          </div>
          <div class="fl-field fl-field--small">
            <label>Fotos</label>
            <input v-model.number="take" type="number" min="1" max="50"/>
          </div>
          <button class="fl-btn" :disabled="loading" @click="searchPoints()">
            <span v-if="!loading">Buscar pontos</span>
            <span v-else>Buscando...</span>
          </button>
        </div>

        <waiting-list :loading-content="loading">

          <div v-if="user" class="fl-card fl-user">
            <img v-if="user.photo" :src="user.photo" class="fl-user__photo" alt="Funcionário"/>
            <span v-else class="fl-user__photo fl-user__photo--empty">{{ initials(user.name) }}</span>
            <div class="fl-user__info">
              <strong>{{ user.name }}</strong>
              <span>{{ user.companyName }}</span>
              <span class="fl-user__meta">
                Matrícula {{ user.code }} · {{ user.email }} · Banco {{ resultBank }}
              </span>
            </div>
            <span class="fl-chip" :class="user.active ? 'fl-chip--ok' : 'fl-chip--off'">
              {{ user.active ? 'Ativo' : 'Inativo' }}
            </span>
          </div>

          <div v-if="message" class="fl-note">{{ message }}</div>

          <div v-if="user" class="fl-columns">

            <div class="fl-card fl-gallery">
              <div class="fl-card__head">
                <h4>Últimos pontos com foto</h4>
                <span class="fl-card__hint">Clique para escolher <strong>uma</strong> foto</span>
              </div>

              <div v-if="points.length" class="fl-grid">
                <div v-for="p in points" :key="p.id" class="fl-shot"
                     :class="{ 'is-selected': selectedPointId === p.id }" @click="selectPoint(p)">
                  <img :src="p.imageUri" :alt="p.date" @error="onImgError($event)"/>
                  <span v-if="selectedPointId === p.id" class="fl-shot__check">
                    <ion-icon name="checkmark-circle"/>
                  </span>
                  <a class="fl-shot__open" :href="p.imageUri" target="_blank" title="Abrir original"
                     @click.stop>
                    <ion-icon name="open-outline"/>
                  </a>
                  <div class="fl-shot__caption">
                    <strong>{{ p.date }}</strong>
                    <span>{{ p.pointType }} · {{ p.deviceType }}</span>
                  </div>
                </div>
              </div>

              <div v-else class="fl-empty">
                <ion-icon name="images-outline"/>
                <span>Nenhum ponto com foto encontrado.</span>
              </div>
            </div>

            <div class="fl-card fl-upload">
              <div class="fl-card__head">
                <h4>Ou envie uma foto</h4>
                <span class="fl-card__hint">JPG / PNG até 10 MB</span>
              </div>

              <div class="fl-drop" :class="{ 'is-active': photoMode === 'upload' }"
                   @click="$refs.faceFile.click()" @dragover.prevent @drop.prevent="onDrop">
                <img v-if="uploadPreview" :src="uploadPreview" class="fl-drop__preview" alt="Foto enviada"/>
                <template v-else>
                  <ion-icon name="cloud-upload-outline"/>
                  <p>Arraste uma foto ou clique para selecionar</p>
                </template>
              </div>

              <input ref="faceFile" type="file" accept="image/png,image/jpeg,image/jpg,image/webp"
                     style="display:none" @change="onFileSelected"/>

              <div v-if="uploadName" class="fl-drop__file">
                <span :title="uploadName">{{ uploadName }}</span>
                <button class="fl-x" title="Remover" @click="clearUpload()"><ion-icon name="close-outline"/></button>
              </div>
            </div>
          </div>

          <div v-if="user" class="fl-columns">

            <div class="fl-card fl-action">
              <div class="fl-card__head">
                <h4>1. Cadastrar / treinar</h4>
                <span class="fl-card__hint">POST /people/enroll/&lbrace;grupo&rbrace;</span>
              </div>

              <div class="fl-field">
                <label>external_id <em>(identificador da pessoa na Zioncor)</em></label>
                <input v-model="externalId" type="text" maxlength="120"/>
              </div>
              <div class="fl-field">
                <label>Nome</label>
                <input v-model="personName" type="text" maxlength="200"/>
              </div>
              <div class="fl-field">
                <label>Empresa (grupo) <em>(companyId — a pessoa é cadastrada neste grupo)</em></label>
                <input v-model="enrollCompanyId" type="text" placeholder="companyId"/>
              </div>

              <div class="fl-selected">
                <span class="fl-selected__label">Foto:</span>
                <img v-if="currentPhoto" :src="currentPhoto" class="fl-selected__thumb" alt="Foto escolhida"/>
                <span class="fl-selected__text">{{ photoLabel }}</span>
              </div>

              <button class="fl-btn fl-btn--block" :disabled="!canSubmit || loadingEnroll" @click="enroll()">
                <span v-if="!loadingEnroll">Cadastrar com esta foto</span>
                <span v-else>Enviando...</span>
              </button>
            </div>

            <div class="fl-card fl-action">
              <div class="fl-card__head">
                <h4>2. Identificar</h4>
                <span class="fl-card__hint">POST /identify{{ identifyCompanyId.trim() ? '/groups/{grupo}' : '' }}</span>
              </div>

              <p class="fl-action__desc">
                Manda a foto escolhida e devolve quem a Zioncor acha que é, com o score de
                similaridade e o limiar usado na decisão.
              </p>

              <div class="fl-field">
                <label>Empresa (grupo) <em>(companyId — em branco = busca em todas as empresas)</em></label>
                <input v-model="identifyCompanyId" type="text" placeholder="companyId (deixe vazio p/ busca global)"/>
              </div>

              <div class="fl-selected">
                <span class="fl-selected__label">Foto:</span>
                <img v-if="currentPhoto" :src="currentPhoto" class="fl-selected__thumb" alt="Foto escolhida"/>
                <span class="fl-selected__text">{{ photoLabel }}</span>
              </div>

              <button class="fl-btn fl-btn--block fl-btn--dark" :disabled="!canSubmit || loadingIdentify"
                      @click="identify()">
                <span v-if="!loadingIdentify">Identificar esta foto</span>
                <span v-else>Analisando...</span>
              </button>
            </div>
          </div>

          <div v-if="enrollResult" class="fl-card fl-result"
               :class="enrollResult.success ? 'fl-result--ok' : 'fl-result--bad'">
            <div class="fl-result__head">
              <ion-icon :name="enrollResult.success ? 'checkmark-circle' : 'close-circle'"/>
              <div>
                <h4>{{ enrollResult.success ? 'Pessoa cadastrada' : 'Falha no cadastro' }}</h4>
                <span>{{ enrollResult.success ? enrollResult.name : enrollResult.errorMessage }}</span>
              </div>
              <button class="fl-x" @click="enrollResult = null"><ion-icon name="close-outline"/></button>
            </div>

            <div v-if="enrollResult.success" class="fl-metrics">
              <div class="fl-metric"><span>person_id</span><strong>{{ enrollResult.personId }}</strong></div>
              <div class="fl-metric"><span>external_id</span><strong class="fl-mono">{{ enrollResult.externalId }}</strong></div>
              <div class="fl-metric">
                <span>Indexada (ready)</span>
                <strong :class="enrollResult.ready ? 'fl-ok' : 'fl-warn'">{{ enrollResult.ready ? 'Sim' : 'Ainda não' }}</strong>
              </div>
              <div class="fl-metric"><span>Ativa</span><strong>{{ enrollResult.active ? 'Sim' : 'Não' }}</strong></div>
              <div class="fl-metric"><span>Grupo (id)</span><strong>{{ enrollResult.groupId }}</strong></div>
              <div class="fl-metric"><span>Grupo (empresa)</span><strong class="fl-mono">{{ enrollResult.groupName }}</strong></div>
              <div class="fl-metric"><span>Foto</span><strong>{{ enrollResult.photoSource }} · {{ size(enrollResult.photoSizeBytes) }}</strong></div>
              <div class="fl-metric"><span>Tempo</span><strong>{{ ms(enrollResult.elapsedMs) }}</strong></div>
            </div>

            <details class="fl-raw">
              <summary>Detalhes técnicos</summary>
              <p class="fl-mono fl-raw__ep">{{ enrollResult.endpoint }} → HTTP {{ enrollResult.httpStatus }}</p>
              <pre class="fl-mono">{{ enrollResult.rawRequest }}</pre>
              <pre class="fl-mono">{{ enrollResult.rawResponse }}</pre>
            </details>
          </div>

          <div v-if="identifyResult" class="fl-card fl-result"
               :class="identifyBannerClass">
            <div class="fl-result__head">
              <ion-icon :name="identifyIcon"/>
              <div>
                <h4>{{ identifyTitle }}</h4>
                <span>{{ identifySubtitle }}</span>
              </div>
              <button class="fl-x" @click="identifyResult = null"><ion-icon name="close-outline"/></button>
            </div>

            <div v-if="identifyResult.success" class="fl-scope">
              <ion-icon :name="identifyResult.groupScope === 'grupo' ? 'funnel-outline' : 'globe-outline'"/>
              <span v-if="identifyResult.groupScope === 'grupo' && identifyResult.groupId">
                Busca <strong>filtrada no grupo</strong> {{ identifyResult.groupId }}
                (<span class="fl-mono">{{ identifyResult.groupName }}</span>)
              </span>
              <span v-else-if="identifyResult.groupScope === 'grupo'">
                Empresa <span class="fl-mono">{{ identifyResult.groupName }}</span> ainda
                <strong>sem grupo cadastrado</strong> na Zioncor — base vazia, nenhuma correspondência
              </span>
              <span v-else>Busca <strong>global</strong> — todas as empresas do cliente</span>
            </div>

            <div v-if="identifyResult.success" class="fl-match">

              <div class="fl-match__photo">
                <span class="fl-match__cap">Foto enviada</span>
                <img v-if="currentPhoto" :src="currentPhoto" alt="Foto analisada"/>
              </div>

              <div class="fl-gauge">
                <svg viewBox="0 0 180 180">
                  <g transform="rotate(-90 90 90)">
                    <circle cx="90" cy="90" r="70" fill="none" stroke="#E6E9EC" stroke-width="18"/>
                    <circle cx="90" cy="90" r="70" fill="none" :stroke="scoreColor" stroke-width="18"
                            stroke-linecap="round" :stroke-dasharray="scoreDash"/>
                  </g>
                  <g :transform="'rotate(' + thresholdAngle + ' 90 90)'">
                    <line x1="90" y1="8" x2="90" y2="32" stroke="#3A424E" stroke-width="3"/>
                  </g>
                  <text x="90" y="88" text-anchor="middle" class="fl-gauge__val">{{ scorePct.toFixed(1) }}%</text>
                  <text x="90" y="108" text-anchor="middle" class="fl-gauge__lbl">score</text>
                </svg>
                <span class="fl-gauge__thr">limiar {{ thresholdPct.toFixed(1) }}%</span>
              </div>

              <div class="fl-match__who">
                <template v-if="identifyResult.matched">
                  <span class="fl-match__cap">Identificado como</span>
                  <div class="fl-match__person">
                    <img v-if="matchedPhoto" :src="matchedPhoto" alt="Pessoa identificada"/>
                    <span v-else class="fl-match__initials">{{ initials(identifyResult.name) }}</span>
                    <div>
                      <strong>{{ identifyResult.name || '(sem nome)' }}</strong>
                      <span class="fl-mono">{{ identifyResult.externalId }}</span>
                      <span v-if="identifyResult.matchedUser">{{ identifyResult.matchedUser.companyName }}</span>
                    </div>
                  </div>
                  <div v-if="isSamePerson !== null" class="fl-verdict"
                       :class="isSamePerson ? 'fl-verdict--ok' : 'fl-verdict--bad'">
                    <ion-icon :name="isSamePerson ? 'checkmark-circle-outline' : 'warning-outline'"/>
                    {{ isSamePerson ? 'É o mesmo funcionário da busca' : 'ATENÇÃO: é outra pessoa, não o funcionário da busca' }}
                  </div>
                </template>
                <template v-else>
                  <span class="fl-match__cap">Resultado</span>
                  <div class="fl-match__none">
                    <ion-icon name="help-circle-outline"/>
                    <span>Nenhuma pessoa da base bateu com esta foto.</span>
                  </div>
                </template>
              </div>
            </div>

            <div v-if="identifyResult.success" class="fl-metrics">
              <div class="fl-metric"><span>Score</span><strong>{{ num(identifyResult.score) }}</strong></div>
              <div class="fl-metric"><span>2º colocado</span><strong>{{ identifyResult.secondScore === null ? '—' : num(identifyResult.secondScore) }}</strong></div>
              <div class="fl-metric">
                <span>Margem OK</span>
                <strong :class="identifyResult.marginOk ? 'fl-ok' : 'fl-warn'">{{ identifyResult.marginOk ? 'Sim' : 'Não' }}</strong>
              </div>
              <div class="fl-metric"><span>Limiar</span><strong>{{ num(identifyResult.threshold) }}</strong></div>
              <div class="fl-metric"><span>Base</span><strong>{{ identifyResult.baseSize }} pessoas</strong></div>
              <div class="fl-metric"><span>Tempo</span><strong>{{ ms(identifyResult.elapsedMs) }}</strong></div>
            </div>

            <details class="fl-raw">
              <summary>Detalhes técnicos</summary>
              <p class="fl-mono fl-raw__ep">{{ identifyResult.endpoint }} → HTTP {{ identifyResult.httpStatus }}</p>
              <pre class="fl-mono">{{ identifyResult.rawRequest }}</pre>
              <pre class="fl-mono">{{ identifyResult.rawResponse }}</pre>
            </details>
          </div>

        </waiting-list>
      </div>
    </box-default>
  </section>
</template>

<script>
import BoxDefault from "../../components/layouts/boxDefault.vue";
import WaitingList from "../../components/layouts/waitingList.vue";
import {FACE_LAB_ENROLL, FACE_LAB_HEALTH, FACE_LAB_IDENTIFY, FACE_LAB_POINTS} from "../../../../urlConfig";
import {REQUEST_SERVICE, UTIL_SERVICE} from "../../../../requestConfig";
import {ALERT_SERVICE} from "../../../../msgAlertService";

export default {
  name: "faceLab",
  components: {BoxDefault, WaitingList},
  data() {
    return {
      banks: ["AAAA", "MMMM", "QQQQ", "RRRR", "TTTT", "XXXX", "NNNN", "EEEE"],

      userId: "",
      bank: "AAAA",
      take: 10,

      loading: false,
      loadingEnroll: false,
      loadingIdentify: false,
      loadingHealth: false,

      user: null,
      points: [],
      message: "",
      resultBank: "",

      photoMode: "",
      selectedPointId: "",
      uploadName: "",
      uploadPreview: "",
      uploadBase64: "",

      externalId: "",
      personName: "",
      enrollCompanyId: "",
      identifyCompanyId: "",

      enrollResult: null,
      identifyResult: null,
      healthResult: null
    };
  },
  computed: {
    context() {
      return (this.bank || "").trim().toUpperCase();
    },
    activeBank() {
      return this.resultBank || this.context;
    },
    selectedPoint() {
      const id = this.selectedPointId;
      if (!id) return null;

      const found = this.points.filter(p => p.id === id);
      return found.length ? found[0] : null;
    },
    currentPhoto() {
      if (this.photoMode === "upload") return this.uploadPreview;
      return this.selectedPoint ? this.selectedPoint.imageUri : "";
    },
    photoLabel() {
      if (this.photoMode === "upload") return this.uploadName || "arquivo enviado";
      if (this.selectedPoint) return "ponto de " + this.selectedPoint.date;
      return "nenhuma foto escolhida";
    },
    canSubmit() {
      return this.photoMode === "upload" ? !!this.uploadBase64 : !!this.selectedPointId;
    },
    matchedPhoto() {
      const r = this.identifyResult;
      if (r && r.matchedUser && r.matchedUser.photo) return r.matchedUser.photo;
      return "";
    },
    scorePct() {
      return this.toPct(this.identifyResult ? this.identifyResult.score : 0);
    },
    thresholdPct() {
      return this.toPct(this.identifyResult ? this.identifyResult.threshold : 0);
    },
    scoreDash() {
      const circ = 2 * Math.PI * 70;
      const filled = circ * Math.min(Math.max(this.scorePct, 0), 100) / 100;
      return filled + " " + circ;
    },
    thresholdAngle() {
      return 360 * Math.min(Math.max(this.thresholdPct, 0), 100) / 100;
    },
    scoreColor() {
      if (!this.identifyResult) return "#E6E9EC";
      if (!this.identifyResult.matched) return "#FF445D";
      return this.scorePct >= this.thresholdPct ? "#2ACC6B" : "#FF9900";
    },
    isSamePerson() {
      const r = this.identifyResult;
      if (!r || !r.matched || !this.user) return null;

      const returned = this.normalizeId(r.externalId);
      return returned === this.normalizeId(this.user.id);
    },
    identifyBannerClass() {
      if (!this.identifyResult.success) return "fl-result--bad";
      return this.identifyResult.matched ? "fl-result--ok" : "fl-result--warn";
    },
    identifyIcon() {
      if (!this.identifyResult.success) return "close-circle";
      return this.identifyResult.matched ? "checkmark-circle" : "help-circle";
    },
    identifyTitle() {
      if (!this.identifyResult.success) return "Falha na identificação";
      return this.identifyResult.matched ? "Rosto identificado" : "Rosto não identificado";
    },
    identifySubtitle() {
      const r = this.identifyResult;
      if (!r.success) return r.errorMessage;
      if (r.matched) return "Score " + this.num(r.score) + " contra limiar " + this.num(r.threshold);
      return "A base tem " + r.baseSize + " pessoa(s) e nenhuma atingiu o limiar de " + this.num(r.threshold) + ".";
    }
  },
  methods: {
    bankIsKnown(value) {
      return this.banks.indexOf((value || "").trim().toUpperCase()) !== -1;
    },

    searchPoints() {
      const id = (this.userId || "").trim();
      if (!id) {
        ALERT_SERVICE.swal("Atenção", "Informe o Id do funcionário.", "warning");
        return;
      }
      if (!this.bankIsKnown(this.context)) {
        ALERT_SERVICE.swal("Atenção", "Informe um banco válido: " + this.banks.join(", ") + ".", "warning");
        return;
      }

      this.loading = true;
      this.resetSelection();
      this.user = null;
      this.points = [];
      this.message = "";

      const url = FACE_LAB_POINTS + "?userId=" + encodeURIComponent(id) + "&take=" + (this.take || 10);

      REQUEST_SERVICE.requestContext("GET", url, this.context)
        .then((response) => {
          UTIL_SERVICE.console("RESULT FACE_LAB_POINTS:", response.data);

          const data = response.data || {};
          this.user = data.user || null;
          this.points = data.points || [];
          this.message = data.message || "";
          this.resultBank = data.bank || this.context;

          if (this.user) {
            this.externalId = this.user.id;
            this.personName = this.user.name;
            this.enrollCompanyId = this.user.companyId;
            this.identifyCompanyId = this.user.companyId;
          }
          if (this.points.length) {
            this.selectPoint(this.points[0]);
          }

          this.loading = false;
        })
        .catch((reason) => {
          this.loading = false;
          this.apiError(reason, "Não foi possível buscar os pontos.");
        });
    },

    selectPoint(point) {
      this.photoMode = "ponto";
      this.selectedPointId = point.id;
      this.uploadName = "";
      this.uploadPreview = "";
      this.uploadBase64 = "";
    },

    onFileSelected(event) {
      const files = event.target.files;
      this.readFile(files && files.length ? files[0] : null);
      event.target.value = "";
    },

    onDrop(event) {
      const files = event.dataTransfer ? event.dataTransfer.files : null;
      this.readFile(files && files.length ? files[0] : null);
    },

    readFile(file) {
      if (!file) return;

      if (file.type && file.type.indexOf("image/") !== 0) {
        ALERT_SERVICE.swal("Atenção", "Selecione um arquivo de imagem (JPG, PNG ou WEBP).", "warning");
        return;
      }
      if (file.size > 10 * 1024 * 1024) {
        ALERT_SERVICE.swal("Atenção", "A foto tem " + this.size(file.size) + ". O limite é 10 MB.", "warning");
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        this.photoMode = "upload";
        this.selectedPointId = "";
        this.uploadName = file.name;
        this.uploadPreview = e.target.result;
        this.uploadBase64 = e.target.result;
      };
      reader.onerror = () => {
        ALERT_SERVICE.swal("Ops...", "Não foi possível ler o arquivo selecionado.", "error");
      };
      reader.readAsDataURL(file);
    },

    clearUpload() {
      this.uploadName = "";
      this.uploadPreview = "";
      this.uploadBase64 = "";

      if (this.points.length) this.selectPoint(this.points[0]);
      else this.photoMode = "";
    },

    enroll() {
      if (!this.canSubmit) return;
      if (!this.ensureBank()) return;

      const external = (this.externalId || "").trim();
      const name = (this.personName || "").trim();

      const enrollCompany = (this.enrollCompanyId || "").trim();

      if (!external) {
        ALERT_SERVICE.swal("Atenção", "Informe o external_id.", "warning");
        return;
      }
      if (!name) {
        ALERT_SERVICE.swal("Atenção", "Informe o nome da pessoa.", "warning");
        return;
      }
      if (!enrollCompany) {
        ALERT_SERVICE.swal("Atenção", "Informe a empresa (companyId) — é o grupo onde a pessoa será cadastrada.", "warning");
        return;
      }

      this.loadingEnroll = true;
      this.enrollResult = null;

      REQUEST_SERVICE.requestContext("POST", FACE_LAB_ENROLL, this.activeBank, this.buildPayload({
        userId: (this.userId || "").trim(),
        externalId: external,
        name: name,
        companyId: enrollCompany
      }))
        .then((response) => {
          UTIL_SERVICE.console("RESULT FACE_LAB_ENROLL:", response.data);
          this.enrollResult = response.data;
          this.loadingEnroll = false;

          if (this.enrollResult && !this.enrollResult.success)
            ALERT_SERVICE.swal("Ops...", this.enrollResult.errorMessage, "error");
        })
        .catch((reason) => {
          this.loadingEnroll = false;
          this.apiError(reason, "Não foi possível cadastrar a pessoa.");
        });
    },

    identify() {
      if (!this.canSubmit) return;
      if (!this.ensureBank()) return;

      this.loadingIdentify = true;
      this.identifyResult = null;

      REQUEST_SERVICE.requestContext("POST", FACE_LAB_IDENTIFY, this.activeBank, this.buildPayload({
        companyId: (this.identifyCompanyId || "").trim()
      }))
        .then((response) => {
          UTIL_SERVICE.console("RESULT FACE_LAB_IDENTIFY:", response.data);
          this.identifyResult = response.data;
          this.loadingIdentify = false;

          if (this.identifyResult && !this.identifyResult.success)
            ALERT_SERVICE.swal("Ops...", this.identifyResult.errorMessage, "error");
        })
        .catch((reason) => {
          this.loadingIdentify = false;
          this.apiError(reason, "Não foi possível identificar a foto.");
        });
    },

    checkHealth() {
      if (!this.ensureBank()) return;

      this.loadingHealth = true;
      this.healthResult = null;

      REQUEST_SERVICE.requestContext("GET", FACE_LAB_HEALTH, this.activeBank)
        .then((response) => {
          UTIL_SERVICE.console("RESULT FACE_LAB_HEALTH:", response.data);
          this.healthResult = response.data;
          this.loadingHealth = false;
        })
        .catch((reason) => {
          this.loadingHealth = false;
          this.apiError(reason, "Não foi possível falar com a API.");
        });
    },

    ensureBank() {
      if (this.bankIsKnown(this.activeBank)) return true;
      ALERT_SERVICE.swal("Atenção", "Informe um banco válido: " + this.banks.join(", ") + ".", "warning");
      return false;
    },

    buildPayload(extra) {
      const payload = extra || {};

      if (this.photoMode === "upload") payload.photoBase64 = this.uploadBase64;
      else payload.userPointId = this.selectedPointId;

      return payload;
    },

    resetSelection() {
      this.photoMode = "";
      this.selectedPointId = "";
      this.uploadName = "";
      this.uploadPreview = "";
      this.uploadBase64 = "";
      this.enrollResult = null;
      this.identifyResult = null;
    },

    onImgError(event) {
      event.target.classList.add("is-broken");
    },

    normalizeId(value) {
      if (!value) return "";
      return String(value).trim().replace(/-/g, "").replace(/[{}]/g, "").toUpperCase();
    },

    initials(name) {
      if (!name) return "?";

      const parts = String(name).trim().split(" ").filter(p => p.length);
      if (!parts.length) return "?";
      if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase();

      return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
    },

    toPct(value) {
      const n = Number(value) || 0;
      return n <= 1 ? n * 100 : n;
    },

    num(value) {
      const n = Number(value);
      if (isNaN(n)) return "—";
      return n.toFixed(4).replace(/0+$/, "").replace(/\.$/, "");
    },

    ms(value) {
      const n = Number(value) || 0;
      return n < 1000 ? Math.round(n) + " ms" : (n / 1000).toFixed(2) + " s";
    },

    size(bytes) {
      const n = Number(bytes) || 0;
      if (n < 1024) return n + " B";
      if (n < 1024 * 1024) return (n / 1024).toFixed(1) + " KB";
      return (n / (1024 * 1024)).toFixed(2) + " MB";
    },

    apiError(reason, fallback) {
      let msg = fallback;

      try {
        const data = reason && reason.response ? reason.response.data : null;
        if (data) {
          if (data.erros && data.erros.length) msg = data.erros.map(e => e.value).join(" ");
          else if (data.message) msg = data.message;
          else if (typeof data === "string" && data.length) msg = data;
        }
      } catch (e) {
        msg = fallback;
      }

      ALERT_SERVICE.swal("Ops...", msg, "error");
    }
  }
};
</script>

<style lang="scss" scoped>
* { font-family: "Montserrat", sans-serif !important; }

$blue: #2F23D6;
$green: #2ACC6B;
$red: #FF445D;
$orange: #FF9900;
$grayText: #7E8DA7;
$dark: #3A424E;

.fl {
  padding-bottom: 40px;

  ion-icon { pointer-events: none; }

  &-card {
    background: #fff;
    border-radius: 10px !important;
    padding: 18px 20px;
    margin-bottom: 18px;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .10), 0 0 0 1px rgba(0, 0, 0, .05);

    &__head {
      display: flex;
      align-items: baseline;
      justify-content: space-between;
      margin-bottom: 14px;

      h4 { margin: 0; font-size: 15px; font-weight: 700; color: $dark; }
    }

    &__hint { font-size: 12px; color: $grayText; }
  }
}

.fl-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 6px 0 18px;

  &__title {
    display: flex;
    align-items: center;
    gap: 14px;

    ion-icon { font-size: 38px; color: $blue; }
    h3 { margin: 0; font-size: 20px; font-weight: 700; color: $dark; }
    span { font-size: 13px; color: $grayText; }
  }
}

.fl-health {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border-radius: 8px !important;
  margin-bottom: 16px;
  font-size: 13px;
  word-break: break-word;

  ion-icon { font-size: 20px; flex: 0 0 auto; }
  &.ok { background: #E6F8EE; color: #08A747; }
  &.bad { background: #fde8e8; color: #c0392b; }
}

.fl-search {
  display: flex;
  align-items: flex-end;
  gap: 14px;
  flex-wrap: wrap;
}

.fl-field {
  display: flex;
  flex-direction: column;
  gap: 6px;

  &--grow { flex: 1 1 320px; }
  &--small { width: 90px; }

  label {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    color: $grayText;
    margin: 0;

    em { font-weight: 500; text-transform: none; font-style: normal; }
  }

  input {
    height: 38px;
    padding: 0 12px;
    border: 1px solid #DDE3EC;
    border-radius: 8px !important;
    font-size: 13px;
    color: $dark;
    outline: none;
    transition: border-color .2s;

    &:focus { border-color: $blue; }
  }
}

.fl-btn {
  height: 38px;
  padding: 0 20px;
  border: none;
  border-radius: 8px !important;
  background: $blue;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: opacity .2s;

  &:hover:enabled { opacity: .88; }
  &:disabled { background: #BFC7D4; cursor: not-allowed; }

  &--ghost {
    background: #fff;
    color: $blue;
    border: 1px solid #DDE3EC;
    &:disabled { background: #fff; color: #BFC7D4; }
  }

  &--dark { background: $dark; }
  &--block { width: 100%; margin-top: 4px; }
}

.fl-x {
  border: none;
  background: transparent;
  cursor: pointer;
  color: inherit;
  padding: 0 2px;
  margin-left: auto;

  ion-icon { font-size: 18px; }
}

.fl-note {
  background: #FFF7DA;
  color: #8a6d00;
  border-radius: 8px !important;
  padding: 10px 14px;
  font-size: 13px;
  margin-bottom: 18px;
}

.fl-user {
  display: flex;
  align-items: center;
  gap: 16px;

  &__photo {
    width: 56px;
    height: 56px;
    border-radius: 50% !important;
    object-fit: cover;
    flex: 0 0 auto;

    &--empty {
      display: flex;
      align-items: center;
      justify-content: center;
      background: #E6E9EC;
      color: $dark;
      font-weight: 700;
      font-size: 18px;
    }
  }

  &__info {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;

    strong { font-size: 15px; color: $dark; }
    span { font-size: 12px; color: $grayText; }
  }

  &__meta { font-size: 11px !important; }
}

.fl-chip {
  margin-left: auto;
  padding: 3px 10px;
  border-radius: 4px !important;
  font-size: 11px;
  font-weight: 600;

  &--ok { background: #E6F8EE; color: #08A747; }
  &--off { background: #fde8e8; color: #c0392b; }
}

.fl-columns {
  display: flex;
  gap: 18px;
  align-items: flex-start;
  flex-wrap: wrap;

  > * { flex: 1 1 380px; min-width: 300px; }
}

.fl-gallery { flex: 2 1 560px; }

.fl-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 14px;
}

.fl-shot {
  position: relative;
  border: 2px solid transparent;
  border-radius: 12px !important;
  padding: 6px;
  cursor: pointer;
  transition: .2s;

  &:hover { background: #F7F9FC; }
  &.is-selected { border-color: $blue; background: #F4F3FE; }

  img {
    width: 100%;
    aspect-ratio: 1 / 1;
    object-fit: cover;
    border-radius: 10px !important;
    display: block;
    background: #E6E9EC;

    &.is-broken { object-fit: contain; padding: 20px; }
  }

  &__check {
    position: absolute;
    top: 12px;
    right: 12px;
    background: #fff;
    border-radius: 50% !important;
    line-height: 0;

    ion-icon { font-size: 22px; color: $blue; }
  }

  &__open {
    position: absolute;
    top: 12px;
    left: 12px;
    opacity: 0;
    transition: .2s;
    background: rgba(0, 0, 0, .45);
    border-radius: 6px !important;
    padding: 3px 4px 1px;
    line-height: 0;

    ion-icon { font-size: 16px; color: #fff; }
  }

  &:hover &__open { opacity: 1; }

  &__caption {
    display: flex;
    flex-direction: column;
    margin-top: 8px;
    text-align: center;

    strong { font-size: 11px; color: $dark; }
    span { font-size: 10px; color: $grayText; }
  }
}

.fl-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 40px 0;
  color: $grayText;

  ion-icon { font-size: 42px; }
  span { font-size: 13px; }
}

.fl-drop {
  border: 2px dashed #BACADC;
  border-radius: 12px !important;
  padding: 26px 16px;
  text-align: center;
  cursor: pointer;
  transition: .2s;

  &:hover { border-color: $blue; background: #F7F9FC; }
  &.is-active { border-color: $blue; background: #F4F3FE; }

  ion-icon { font-size: 42px; color: $blue; }
  p { margin: 8px 0 0; font-size: 13px; color: $grayText; }

  &__preview {
    max-width: 100%;
    max-height: 220px;
    border-radius: 10px !important;
  }

  &__file {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 10px;
    font-size: 12px;
    color: $dark;

    span { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  }
}

.fl-action {
  display: flex;
  flex-direction: column;
  gap: 12px;

  &__desc { font-size: 13px; color: $grayText; margin: 0; }
}

.fl-selected {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #F7F9FC;
  border-radius: 8px !important;
  padding: 8px 12px;

  &__label { font-size: 11px; font-weight: 700; text-transform: uppercase; color: $grayText; }
  &__thumb { width: 34px; height: 34px; object-fit: cover; border-radius: 6px !important; }
  &__text { font-size: 12px; color: $dark; }
}

.fl-result {
  border-left: 5px solid #E6E9EC;

  &--ok { border-left-color: $green; }
  &--warn { border-left-color: $orange; }
  &--bad { border-left-color: $red; }

  &__head {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 16px;

    ion-icon { font-size: 32px; flex: 0 0 auto; }
    h4 { margin: 0; font-size: 16px; font-weight: 700; color: $dark; }
    span { font-size: 12px; color: $grayText; }
  }

  &--ok &__head ion-icon { color: $green; }
  &--warn &__head ion-icon { color: $orange; }
  &--bad &__head ion-icon { color: $red; }
}

.fl-scope {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #F4F3FE;
  color: $blue;
  border-radius: 8px !important;
  padding: 8px 12px;
  margin-bottom: 16px;
  font-size: 13px;

  ion-icon { font-size: 18px; flex: 0 0 auto; }
  .fl-mono { word-break: break-all; }
}

.fl-match {
  display: flex;
  align-items: center;
  gap: 26px;
  flex-wrap: wrap;
  padding-bottom: 18px;

  &__cap {
    display: block;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    color: $grayText;
    margin-bottom: 8px;
  }

  &__photo {
    flex: 0 0 auto;
    img { width: 150px; height: 150px; object-fit: cover; border-radius: 12px !important; }
  }

  &__who { flex: 1 1 240px; min-width: 220px; }

  &__person {
    display: flex;
    align-items: center;
    gap: 12px;

    img, .fl-match__initials {
      width: 52px;
      height: 52px;
      border-radius: 50% !important;
      object-fit: cover;
      flex: 0 0 auto;
    }

    div { display: flex; flex-direction: column; gap: 2px; min-width: 0; }
    strong { font-size: 15px; color: $dark; }
    span { font-size: 11px; color: $grayText; word-break: break-all; }
  }

  &__initials {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #E6E9EC;
    color: $dark;
    font-weight: 700;
  }

  &__none {
    display: flex;
    align-items: center;
    gap: 10px;
    color: $grayText;
    font-size: 13px;

    ion-icon { font-size: 26px; }
  }
}

.fl-verdict {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 14px;
  padding: 8px 12px;
  border-radius: 8px !important;
  font-size: 12px;
  font-weight: 600;

  ion-icon { font-size: 18px; }
  &--ok { background: #E6F8EE; color: #08A747; }
  &--bad { background: #fde8e8; color: #c0392b; }
}

.fl-gauge {
  flex: 0 0 auto;
  text-align: center;

  svg { width: 170px; height: 170px; }
  &__val { font-size: 26px; font-weight: 700; fill: #3A424E; }
  &__lbl { font-size: 11px; fill: #7E8DA7; text-transform: uppercase; }
  &__thr { display: block; font-size: 11px; color: $grayText; margin-top: -6px; }
}

.fl-metrics {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  border-top: 1px solid #EFF2F6;
  padding-top: 14px;
}

.fl-metric {
  flex: 1 1 130px;
  min-width: 120px;
  background: #F7F9FC;
  border-radius: 8px !important;
  padding: 10px 12px;

  span { display: block; font-size: 10px; font-weight: 700; text-transform: uppercase; color: $grayText; }
  strong { display: block; font-size: 14px; color: $dark; margin-top: 4px; word-break: break-all; }
}

.fl-ok { color: #08A747 !important; }
.fl-warn { color: #B58A00 !important; }

.fl-raw {
  margin-top: 14px;

  summary { cursor: pointer; font-size: 12px; font-weight: 600; color: $grayText; }

  pre {
    background: #F7F9FC;
    border: 1px solid #EFF2F6;
    border-radius: 8px !important;
    padding: 10px 12px;
    margin-top: 8px;
    font-size: 11px;
    max-height: 260px;
    overflow: auto;
    white-space: pre-wrap;
    word-break: break-word;
  }

  &__ep { font-size: 11px; color: $grayText; margin: 8px 0 0; }
}

.fl-mono { font-family: "Courier New", monospace !important; }
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/faceLab/faceLab.vue